'use strict';

angular.module('licensure.services')
    .factory('LicenseRequests', ['$http', '$q', 'FBResponses', 'Logger', '$rootScope', function ($http, $q, FBResponses, Logger, $rootScope) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/LicensingModule/LicenseRequest', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },

            getByUserID: function (user_id, detail, enterprise_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/LicenseRequests/getByUserID/', {
                        params: {
                            user_id: user_id,
                            detail: detail,
                            enterprise_id: enterprise_id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/LicenseRequests/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getXML: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/LicenseRequests/getXML', {
                    params: {
                        licenseRequestID: id
                    }
                }).
                    then(function (response) {
                        var formatted = '';
                        if (response.data != null) {
                            var reg = /(>)(<)(\/*)/g;
                            response.data = response.data.replace(reg, '$1\r\n$2$3');
                            var pad = 0;
                            var array = response.data.split('\r\n');
                            for (var index = 0; index < array.length; index++) {
                                var indent = 0;
                                if (array[index].match(/.+<\/\w[^>]*>$/)) {
                                    indent = 0;
                                } else if (array[index].match(/^<\/\w/)) {
                                    if (pad != 0) {
                                        pad -= 1;
                                    }
                                } else if (array[index].match(/^<\w[^>]*[^\/]>.*$/)) {
                                    indent = 1;
                                } else {
                                    indent = 0;
                                }

                                var padding = '';
                                for (var i = 0; i < pad; i++) {
                                    padding += '  ';
                                }

                                formatted += padding + array[index] + '\r\n';
                                pad += indent;
                            }
                        }
                        d.resolve(formatted);
                    }).
                    catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getTrainingValidationDates: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/LicenseRequests/getTrainingValidationDates', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (license_request) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/LicenseRequests/';
                if (!isUndefined(license_request.id)) {
                    method = 'PUT'
                    url += license_request.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        license_request: license_request
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        Logger.logAngularApiErrors(response.data, response.status, response.config);
                    });

                return d.promise;
            },

            submit: function (application, response, parameters, connectionId) {
                var d = $q.defer();
                var result = {
                    success: true,
                    error: null,
                    validationError: false
                }
                try {
                    response.completed_on = new Date();
                    response.progress = 2;

                    // copy for pdf because it already has all the options loaded in
                    var pdfResponseCopy = angular.copy(response);

                    var getDocumentIDs = false;

                    pdfResponseCopy.form.pages.forEach(function (page) {
                        if (getDocumentIDs == false) {
                            page.sections.forEach(function (section) {
                                if (getDocumentIDs == false) {
                                    section.components.forEach(function (component) {
                                        if (getDocumentIDs == false) {
                                            component.groups.forEach(function (group) {
                                                if (getDocumentIDs == false) {
                                                    group.questions.forEach(function (question) {
                                                        if (getDocumentIDs == false) {
                                                            if (question.question_type.code == 'file_upload') {
                                                                getDocumentIDs = true;
                                                            }
                                                        }
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    });

                    $rootScope.$broadcast('generate:pdf');
                    var responsePromise;
                    if (getDocumentIDs == true || pdfResponseCopy.form.display_changed_answers) {
                        // we need to go get response because pdfResponseCopy will not have document IDs tied to file Upload documents
                        responsePromise = FBResponses.getByID(response.id);
                    } else {
                        // use the existing response
                        responsePromise = $q.when(pdfResponseCopy);
                    }
                    responsePromise.then(function (pdfResponse) {
                        if (pdfResponse != null) {
                            // get html for pdf
                            FBResponses.generatePDFHTML(pdfResponse.form, parameters).then(function (pdfHtml) {
                                $rootScope.$broadcast('reset:application');

                                // submit form
                                FBResponses.saveByForm(response, application.id, null, true, false, false, false, pdfHtml, connectionId).then(function (savedResponse) {
                                    if (savedResponse != null) {
                                        if (savedResponse == false) {
                                            // server-side validation failed
                                            result.success = false;
                                            result.validationError = true;
                                            d.resolve(result);
                                        }
                                        else {
                                            result.success = true;
                                            d.resolve(result);
                                        }
                                    }
                                    else {
                                        result.success = false;
                                        d.resolve(result);
                                    }
                                });
                            });
                        }
                    });
                }
                catch (e) {
                    result.success = false;
                    result.error = e;
                    d.resolve(result);
                }

                return d.promise;
            },

            delete: function (id, reason) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/LicenseRequests/' + id, {
                    params: {
                        reason: reason
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            setCurrentTriggerCount: function (licenseRequestID, count) {
                var d = $q.defer();

                if (count == null) {
                    count = 0;
                }

                var data = {
                    licenseRequestID: licenseRequestID,
                    count: count
                }

                $http({
                    method: 'POST',
                    url: apiLocation + '/api/LicenseRequests/setCurrentTriggerCount',
                    data: data
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },
        }
    }])
    ;